import { SyntheticEvent, useRef } from "react"
import { Box } from "@mui/material"
import Tabs, { tabsClasses } from "@mui/material/Tabs"
import { IconButton, ThemeProvider } from "@mui/material"
import { CustomTab, LeftIcon, RightIcon, theme } from "./Atom"
import { useSelector } from "react-redux"

export default function DashboardTabs(props: any) {
  const { fetchByDashboardTabId } = props
  const tabsRef = useRef<any>(null)

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    const tab = dashboardTabs[newValue]
    if (tab) {
      fetchByDashboardTabId(tab)
    }
  }

  const selectedDashboardTab = useSelector((state: any) => {
    return state.dashboard.selectedDashboardTab
  })

  const dashboardTabs = useSelector((state: any) => {
    return state.dashboard.dashboardTabs
  })

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          flexGrow: 0,
          maxWidth: { xs: "100%", sm: "100%", xl: "100%", md: "100%" },
          bgcolor: "#1A428A",
          display: "flex",
          alignItems: "flex-end",
          color: "primary.main",
          height: "8vh",
        }}
      >
        <Tabs
          ref={tabsRef}
          scrollButtons="auto"
          // ScrollButtonComponent={(props: any) => {
          // if (props.direction === "left") {
          //   return (
          //     <IconButton
          //       size="small"
          //       style={{ right: 36 }}
          //       {...props}
          //       disableRipple={true}
          //     >
          //       <LeftIcon disabled={props.disabled} />
          //     </IconButton>
          //   )
          // } else if (props.direction === "right") {
          //   return (
          //     <IconButton
          //       size="small"
          //       style={{ right: 0 }}
          //       {...props}
          //       disableRipple={true}
          //     >
          //       <RightIcon disabled={props.disabled} />
          //     </IconButton>
          //   )
          // } else {
          //   return null
          // }
          // }
          // }
          value={selectedDashboardTab?.index || 0}
          onChange={handleChange}
          variant="scrollable"
          aria-label="visible arrows tabs example"
          sx={{
            color: "primary.main",
            position: "relative",
            // height: 56,
            paddingRight: 13,
            [`& .${tabsClasses.scrollButtons}`]: {
              position: "absolute",
              "&.Mui-disabled": { opacity: 0.9 },
            },
          }}
          TabIndicatorProps={{
            style: { display: "none" },
          }}
        >
          {dashboardTabs.map((tab: any, index: any) => (
            <CustomTab
              key={tab?.id}
              label={tab?.name}
              onClick={() => fetchByDashboardTabId(tab)}
              style={{
                backgroundColor:
                  selectedDashboardTab?.index === index ? "#ffffff" : "#1c56ce",
                color:
                  selectedDashboardTab?.index === index ? "black" : "white",
                marginLeft: index === 0 ? "8px" : "0",
                fontSize:
                  selectedDashboardTab?.index === index ? "16px" : "16px",
                fontWeight:
                  selectedDashboardTab?.index === index ? "600" : "400",
                width: "fit-content",
                textTransform: "capitalize",
              }}
            />
          ))}
        </Tabs>
      </Box>
    </ThemeProvider>
  )
}
